interface IconProps extends React.SVGAttributes<SVGElement> {
  className?: string;
  size?: string | number;
  color?: string;
  strokeWidth?: string | number;
}

export const PingAreaIcon = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M7 17L17 7M12 17L17 12M7 12L12 7M6 8L8 6M16 18L18 16M5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingHideLandmarkIcon = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3 22H18M6 18V11M10 18V10M14 18V14M18 11V14M2 2L10 10M22 22L14 14M11.75 7H20L12 2L8.4 4.25M14 14L10 10M7 7H4L5.84615 5.84615"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingElevationProfileIcon = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M14.75 4.5L11.0938 9H7.71875L4.0625 13.5M19 21H6.15146C4.8884 21 4.19081 19.5344 4.98728 18.5541L10.3125 12H13.6875L18.3358 6.27898C19.2264 5.18293 21 5.81264 21 7.22487V19C21 20.1046 20.1046 21 19 21Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Ping3DIcon = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M2.5 14.875C2.5 16.4628 4.067 17.75 6 17.75C7.933 17.75 9.5 16.4628 9.5 14.875C9.5 13.2872 8.10137 11.75 6 11.75M6 11.75C8.11235 11.75 9.5 10.3247 9.5 8.875C9.5 7.42525 7.933 6.25 6 6.25C4.067 6.25 2.5 7.42525 2.5 8.875M6 11.75H5M12.75 6.5H16.75C18.0761 6.5 19.3479 7.07946 20.2855 8.11091C21.2232 9.14236 21.75 10.5413 21.75 12C21.75 13.4587 21.2232 14.8576 20.2855 15.8891C19.3479 16.9205 18.0761 17.5 16.75 17.5H12.75V6.5Z"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export const PingPlaceholderIcon = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M15 18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18C9 16.3431 10.3431 15 12 15C13.6569 15 15 16.3431 15 18Z"
        stroke={color}
        strokeWidth={strokeWidth}
      />
      <path
        d="M15 6C15 7.65685 13.6569 9 12 9C10.3431 9 9 7.65685 9 6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6Z"
        stroke={color}
        strokeWidth={strokeWidth}
      />
      <path
        d="M18 9C19.6569 9 21 10.3431 21 12C21 13.6569 19.6569 15 18 15C16.3431 15 15 13.6569 15 12C15 10.3431 16.3431 9 18 9Z"
        stroke={color}
        strokeWidth={strokeWidth}
      />
      <path
        d="M6 9C7.65685 9 9 10.3431 9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9Z"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export const PingElevationIcon = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M11.75 20.25H20.25M11.75 3.75L20.25 3.75M11.75 7.75L16.25 7.75M11.75 16.25H16.25M11.75 12H20.25M5.25 5.75C6.07843 5.75 6.75 5.07843 6.75 4.25C6.75 3.42157 6.07843 2.75 5.25 2.75C4.42157 2.75 3.75 3.42157 3.75 4.25C3.75 5.07843 4.42157 5.75 5.25 5.75ZM5.25 5.75L5.25 18.25M5.25 18.25C4.42157 18.25 3.75 18.9216 3.75 19.75C3.75 20.5784 4.42157 21.25 5.25 21.25C6.07843 21.25 6.75 20.5784 6.75 19.75C6.75 18.9216 6.07843 18.25 5.25 18.25Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingLocationIcon = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M8 16.0142C5.32211 16.393 3.5 17.1402 3.5 18C3.5 19.2426 7.30558 20.25 12 20.25C16.6944 20.25 20.5 19.2426 20.5 18C20.5 17.1402 18.6779 16.393 16 16.0142M12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3C9.51472 3 7.5 5.01472 7.5 7.5C7.5 9.98528 9.51472 12 12 12ZM12 12V17"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};

export const PingAccuracyIconLow = ({
  className,
  size = 24,
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M2 20H2.01M7 20V16M12 20V12M17 20V8M22 4V20"
        stroke="#BCBBC6"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 20H2.01M7 20V16"
        stroke="#D52B50"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingAccuracyIconMedium = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M2 20H2.01M7 20V16M12 20V12M17 20V8M22 4V20"
        stroke="#BCBBC6"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 20H2.01M7 20V16M12 20V12"
        stroke="#F6AE1F"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingAccuracyIconHigh = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M2 20H2.01M7 20V16M12 20V12M17 20V8M22 4V20"
        stroke="#BCBBC6"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 20H2.01M7 20V16M12 20V12M17 20V8"
        stroke="#1FAF7B"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingAccuracyIconVeryHigh = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 20H2.01M7 20V16M12 20V12M17 20V8M22 4V20"
        stroke="#BCBBC6"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 20H2.01M7 20V16M12 20V12M17 20V8M22 4V20"
        stroke="#1FAF7B"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingNotGeocodedIcon = ({
  size = 24,
  color = "#FF667D",
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4866 11.9995L9.15329 2.66617C9.037 2.46097 8.86836 2.29029 8.66457 2.17154C8.46078 2.0528 8.22915 1.99023 7.99329 1.99023C7.75743 1.99023 7.52579 2.0528 7.322 2.17154C7.11822 2.29029 6.94958 2.46097 6.83329 2.66617L1.49995 11.9995C1.38241 12.2031 1.32077 12.4341 1.32129 12.6692C1.32181 12.9042 1.38447 13.135 1.50292 13.338C1.62136 13.5411 1.79138 13.7092 1.99575 13.8254C2.20011 13.9415 2.43156 14.0016 2.66662 13.9995H13.3333C13.5672 13.9993 13.797 13.9375 13.9995 13.8204C14.202 13.7032 14.3701 13.5349 14.487 13.3322C14.6038 13.1296 14.6653 12.8998 14.6653 12.6658C14.6652 12.4319 14.6036 12.2021 14.4866 11.9995Z"
        fill={color}
      />
      <path
        d="M8 6V8.66667M8 11.3333H8.00667"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingGeocodedIcon = ({
  size = 24,
  color = "#A1DCBD",
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99968 14.6663C11.6816 14.6663 14.6663 11.6816 14.6663 7.99968C14.6663 4.31778 11.6816 1.33301 7.99968 1.33301C4.31778 1.33301 1.33301 4.31778 1.33301 7.99968C1.33301 11.6816 4.31778 14.6663 7.99968 14.6663Z"
        fill={color}
      />
      <path d="M5.99967 7.99968L7.33301 9.33301L9.99967 6.66634" fill={color} />
      <path
        d="M6 8.00033L7.33333 9.33366L10 6.66699"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingHeatmapIcon = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M4.66659 14.6663C6.50753 14.6663 7.99992 13.174 7.99992 11.333C7.99992 9.49206 6.50753 7.99967 4.66659 7.99967C2.82564 7.99967 1.33325 9.49206 1.33325 11.333C1.33325 13.174 2.82564 14.6663 4.66659 14.6663Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9999 9.99967C13.4727 9.99967 14.6666 8.80577 14.6666 7.33301C14.6666 5.86025 13.4727 4.66634 11.9999 4.66634C10.5272 4.66634 9.33325 5.86025 9.33325 7.33301C9.33325 8.80577 10.5272 9.99967 11.9999 9.99967Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33325 5.33301C6.43782 5.33301 7.33325 4.43758 7.33325 3.33301C7.33325 2.22844 6.43782 1.33301 5.33325 1.33301C4.22868 1.33301 3.33325 2.22844 3.33325 3.33301C3.33325 4.43758 4.22868 5.33301 5.33325 5.33301Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingGeocodingAccuracyOriginalIcon = ({
  className,
  size = 20,
  color = "#656679",
  strokeWidth = 1.25,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M16.6667 8.33333C16.6667 6.56522 15.9643 4.86953 14.7141 3.61929C13.4638 2.36904 11.7682 1.66666 10 1.66666C8.23193 1.66666 6.53624 2.36904 5.286 3.61929C4.03575 4.86953 3.33337 6.56522 3.33337 8.33333C3.33337 12.4942 7.94921 16.8275 9.49921 18.1658C9.64368 18.2742 9.81945 18.3327 10 18.3325M18.3334 18.3333C18.3334 17.6703 18.07 17.0344 17.6011 16.5656C17.1323 16.0967 16.4964 15.8333 15.8334 15.8333M15.8334 15.8333C15.1703 15.8333 14.5344 16.0967 14.0656 16.5656C13.5968 17.0344 13.3334 17.6703 13.3334 18.3333M15.8334 15.8333C16.7538 15.8333 17.5 15.0871 17.5 14.1667C17.5 13.2462 16.7538 12.5 15.8334 12.5C14.9129 12.5 14.1667 13.2462 14.1667 14.1667C14.1667 15.0871 14.9129 15.8333 15.8334 15.8333ZM12.5 8.33333C12.5 9.71404 11.3808 10.8333 10 10.8333C8.61933 10.8333 7.50004 9.71404 7.50004 8.33333C7.50004 6.95262 8.61933 5.83333 10 5.83333C11.3808 5.83333 12.5 6.95262 12.5 8.33333Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingGeocodingAccuracyPointIcon = ({
  className,
  size = 20,
  color = "#1FAF7B",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M10.3625 1.0498C12.1645 1.13933 13.8744 1.89577 15.1562 3.17749C16.5234 4.54472 17.2923 6.39906 17.2925 8.33252L17.2778 8.76221C17.1345 10.9049 15.9476 12.9985 14.6631 14.6863C13.6246 16.0508 12.4767 17.2071 11.6345 17.9883L10.9094 18.6389L10.8765 18.6646C10.6554 18.8308 10.3925 18.9304 10.1184 18.9526L10 18.9575C9.72343 18.9574 9.4536 18.8787 9.22119 18.7317L9.12354 18.6646C9.11253 18.6563 9.10101 18.6479 9.09058 18.6389C8.29975 17.9561 6.72273 16.5055 5.33813 14.6863C3.96789 12.8859 2.70874 10.6236 2.70874 8.33252C2.70897 6.39896 3.47772 4.54474 4.84497 3.17749C6.21231 1.81028 8.06638 1.04137 10 1.04126L10.3625 1.0498Z"
        fill={color}
      />
      <path
        d="M13.1503 6.46607C13.3847 6.20527 13.7945 6.17711 14.0656 6.40259C14.3365 6.62827 14.367 7.02286 14.1328 7.28394L9.64756 12.2839C9.51807 12.4281 9.32687 12.508 9.12906 12.5C8.98066 12.494 8.84094 12.4382 8.73099 12.3462L8.6321 12.2424L6.74318 9.74243L6.67726 9.63257C6.55243 9.36802 6.63286 9.04722 6.88643 8.86963C7.14002 8.69204 7.48247 8.71648 7.70539 8.91236L7.79286 9.00757L9.19878 10.8691L13.1503 6.46607Z"
        fill="white"
      />
    </svg>
  );
};

export const PingGeocodingAccuracyNonPointIcon = ({
  className,
  size = 20,
  color = "#FF667D",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M10.3625 1.0498C12.1645 1.13933 13.8744 1.89577 15.1562 3.17749C16.5234 4.54472 17.2923 6.39906 17.2925 8.33252L17.2778 8.76221C17.1345 10.9049 15.9476 12.9985 14.6631 14.6863C13.6246 16.0508 12.4767 17.2071 11.6345 17.9883L10.9094 18.6389L10.8765 18.6646C10.6554 18.8308 10.3925 18.9304 10.1184 18.9526L10 18.9575C9.72343 18.9574 9.4536 18.8787 9.22119 18.7317L9.12354 18.6646C9.11253 18.6563 9.10101 18.6479 9.09058 18.6389C8.29975 17.9561 6.72273 16.5055 5.33813 14.6863C3.96789 12.8859 2.70874 10.6236 2.70874 8.33252C2.70897 6.39896 3.47772 4.54474 4.84497 3.17749C6.21231 1.81028 8.06638 1.04137 10 1.04126L10.3625 1.0498Z"
        fill={color}
      />
      <path
        d="M10.0092 13.7494L10.1349 13.7628C10.4196 13.8211 10.6341 14.0725 10.6342 14.3744C10.6342 14.6764 10.4197 14.9289 10.1349 14.9872L10.0092 14.9994H10.0006C9.65543 14.9994 9.37561 14.7196 9.37561 14.3744C9.37569 14.0293 9.65548 13.7494 10.0006 13.7494H10.0092ZM9.37561 11.8744V10.6244C9.37561 10.2792 9.65543 9.99939 10.0006 9.99939C11.0361 9.99939 11.8756 9.15992 11.8756 8.12439C11.8756 7.08886 11.0361 6.24939 10.0006 6.24939C8.96508 6.24939 8.12561 7.08886 8.12561 8.12439C8.12561 8.46957 7.84579 8.74939 7.50061 8.74939C7.15543 8.74939 6.87561 8.46957 6.87561 8.12439C6.87561 6.3985 8.27472 4.99939 10.0006 4.99939C11.7265 4.99939 13.1256 6.3985 13.1256 8.12439C13.1256 9.63617 12.0519 10.8963 10.6256 11.1859V11.8744C10.6256 12.2196 10.3458 12.4994 10.0006 12.4994C9.65543 12.4994 9.37561 12.2196 9.37561 11.8744Z"
        fill="white"
      />
    </svg>
  );
};

export const PingGeocoderOldIcon = ({
  className,
  size = 20,
  color = "#656679",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M19.914 11.105C19.9706 10.7394 19.9994 10.37 20 10C20 7.87827 19.1571 5.84344 17.6569 4.34315C16.1566 2.84285 14.1217 2 12 2C9.87827 2 7.84344 2.84285 6.34315 4.34315C4.84285 5.84344 4 7.87827 4 10C4 14.993 9.539 20.193 11.399 21.799C11.5723 21.9293 11.7832 21.9998 12 21.9998C12.2168 21.9998 12.4277 21.9293 12.601 21.799C12.8799 21.5578 13.1546 21.3117 13.425 21.061M16.75 21.75V13.75L22.25 16.75L16.75 19.5682M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingUploadedFileIcon = ({
  className,
  size = 20,
  color = "#656679",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M5.33398 26V6.00002C5.33398 4.15907 6.82637 2.66669 8.66732 2.66669H20.0007V6.66669C20.0007 8.13945 21.1946 9.33335 22.6673 9.33335H26.6673V26C26.6673 27.841 25.1749 29.3334 23.334 29.3334H8.66732C6.82637 29.3334 5.33398 27.841 5.33398 26Z"
        fill="#FF6C47"
        stroke={color}
      />
      <path
        d="M13.3327 21.6666C13.885 21.6666 14.3327 22.1144 14.3327 22.6666C14.3327 23.2189 13.885 23.6666 13.3327 23.6666H10.666C10.1137 23.6666 9.66602 23.2189 9.66602 22.6666C9.66602 22.1144 10.1137 21.6666 10.666 21.6666H13.3327ZM21.3327 21.6666C21.885 21.6666 22.3327 22.1144 22.3327 22.6666C22.3327 23.2189 21.885 23.6666 21.3327 23.6666H18.666C18.1137 23.6666 17.666 23.2189 17.666 22.6666C17.666 22.1144 18.1137 21.6666 18.666 21.6666H21.3327ZM13.3327 16.3333C13.885 16.3333 14.3327 16.781 14.3327 17.3333C14.3327 17.8856 13.885 18.3333 13.3327 18.3333H10.666C10.1137 18.3333 9.66602 17.8856 9.66602 17.3333C9.66602 16.781 10.1137 16.3333 10.666 16.3333H13.3327ZM21.3327 16.3333C21.885 16.3333 22.3327 16.781 22.3327 17.3333C22.3327 17.8856 21.885 18.3333 21.3327 18.3333H18.666C18.1137 18.3333 17.666 17.8856 17.666 17.3333C17.666 16.781 18.1137 16.3333 18.666 16.3333H21.3327Z"
        fill="white"
        stroke={color}
      />
      <path
        d="M20 2.66669V6.66669C20 8.13945 21.1939 9.33335 22.6667 9.33335H26.6667L20 2.66669Z"
        fill="#FFC1AB"
        stroke={color}
      />
    </svg>
  );
};

export const PingInceptionDateIcon = ({
  className,
  size = 20,
  color = "#66676B",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M8 2V6M16 2V6M3 10H20C20.5523 10 21 9.55228 21 9V6C21 4.89543 20.1046 4 19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H10M21.4265 17.1258L15.4856 13.8254C14.8191 13.4551 14 13.937 14 14.6995V21.3005C14 22.063 14.8191 22.5449 15.4856 22.1746L21.4265 18.8742C22.1123 18.4932 22.1123 17.5068 21.4265 17.1258Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingExpirationDateIcon = ({
  className,
  size = 20,
  color = "#66676B",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M20 14V18M20 22V22.01M8 2V6M16 2V6M3 10H21V6C21 4.89543 20.1046 4 19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22C5 22 10.8758 22 14 22"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 14V18M20 22V22.01M8 2V6M16 2V6M3 10H21V6C21 4.89543 20.1046 4 19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22C5 22 10.8758 22 14 22"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingHurricaneIcon = ({
  className,
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3203 2.03027C10.5096 2.76231 10 3.82169 10 5C10 5.42132 10.0666 5.8268 10.1875 6.20801C10.7792 6.07024 11.3873 6.00003 12 6C13.4041 6.00001 14.7839 6.37026 16 7.07227C17.2159 7.77431 18.2256 8.78414 18.9277 10C19.6299 11.2161 20 12.5958 20 14C20 15.4043 19.6299 16.7838 18.9277 18C18.2256 19.216 17.216 20.2256 16 20.9277C14.9809 21.5161 13.8467 21.8712 12.6797 21.9707C13.4907 21.2386 14 20.1786 14 19C14 18.5786 13.9325 18.1733 13.8115 17.792C13.2201 17.9296 12.6124 18 12 18C10.5958 18 9.21608 17.6298 8 16.9277C6.78406 16.2256 5.77435 15.216 5.07227 14C4.37012 12.7838 4 11.4043 4 10C4 8.59571 4.37012 7.21615 5.07227 6C5.77435 4.78405 6.78406 3.77436 8 3.07227C9.0191 2.48392 10.1533 2.12982 11.3203 2.03027ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingFloodIcon = ({
  className,
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_488_2062)">
        <path
          d="M18.8705 6.89743L17.3566 5.86226M17.3566 5.86226L13.0968 2.83206C12.5052 2.41125 11.6857 2.54105 11.2532 3.12406L8.1382 7.32231M17.3566 5.86226L18.3563 12.1736M8.1382 7.32231L7.01828 8.77465M8.1382 7.32231L8.88621 12.0451M2.00002 13C2.60002 13.5 3.20002 14 4.50002 14C7.00002 14 7.00002 12 9.50002 12C12.1 12 11.9 14 14.5 14C17 14 17 12 19.5 12C20.8 12 21.4 12.5 22 13M2.00002 19C2.60002 19.5 3.20002 20 4.50002 20C7.00002 20 7.00002 18 9.50002 18C12.1 18 11.9 20 14.5 20C17 20 17 18 19.5 18C20.8 18 21.4 18.5 22 19"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_488_2062">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PingEarthquakeIcon = ({
  className,
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M21 11L19 9.11114M19 9.11114L13.4 3.62222C12.6223 2.85997 11.3777 2.85997 10.6 3.62223L5 9.11114M19 9.11114V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V9.11114M5 9.11114L3 11M5 14H7L8.5 15.5L11 9.49999L13 17.5L15.5 12.5L17 14H19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingWildfireIcon = ({
  className,
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M15.0001 9H15.2001C15.4043 9.01843 15.6093 8.97361 15.7872 8.87162C15.9651 8.76963 16.1074 8.6154 16.1947 8.42984C16.2821 8.24428 16.3102 8.03636 16.2754 7.83425C16.2406 7.63215 16.1445 7.44564 16.0001 7.3L12.0001 3L8.00007 7.3C7.85568 7.44564 7.75956 7.63215 7.72474 7.83425C7.68992 8.03636 7.71808 8.24428 7.8054 8.42984C7.89273 8.6154 8.03499 8.76963 8.21291 8.87162C8.39084 8.97361 8.59581 9.01843 8.80007 9H9.00007L6.00007 12.3C5.86302 12.4398 5.77002 12.6167 5.73258 12.8088C5.69513 13.001 5.7149 13.1998 5.78943 13.3808C5.86396 13.5619 5.98998 13.717 6.15185 13.8271C6.31372 13.9371 6.50434 13.9973 6.70007 14H7.00007L4.00007 17.3C3.86302 17.4398 3.77002 17.6167 3.73258 17.8088C3.69513 18.001 3.7149 18.1998 3.78943 18.3808C3.86396 18.5618 3.98998 18.717 4.15185 18.8271C4.31372 18.9371 4.50434 18.9973 4.70007 19H10M12 22L12.0001 21M15.75 17.4474C16.0815 17.4474 16.3995 17.3226 16.6339 17.1005C16.8683 16.8784 17 16.5772 17 16.2632C17 15.6095 16.75 15.3158 16.5 14.8421C15.964 13.827 16.388 12.9218 17.5 12C17.75 13.1842 18.5 14.3211 19.5 15.0789C20.5 15.8368 21 16.7368 21 17.6842C21 18.1196 20.9095 18.5508 20.7336 18.9531C20.5577 19.3554 20.2999 19.7209 19.9749 20.0288C19.6499 20.3367 19.264 20.581 18.8394 20.7476C18.4148 20.9142 17.9596 21 17.5 21C17.0404 21 16.5852 20.9142 16.1606 20.7476C15.736 20.581 15.3501 20.3367 15.0251 20.0288C14.7001 19.7209 14.4423 19.3554 14.2664 18.9531C14.0905 18.5508 14 18.1196 14 17.6842C14 17.1381 14.2165 16.5976 14.5 16.2632C14.5 16.5772 14.6317 16.8784 14.8661 17.1005C15.1005 17.3226 15.4185 17.4474 15.75 17.4474Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingSCSIcon = ({ className, size = 24, ...props }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3.99997 14.899C3.25701 14.1399 2.69654 13.2217 2.36101 12.214C2.02547 11.2062 1.92368 10.1353 2.06333 9.08232C2.20299 8.02938 2.58043 7.02202 3.16707 6.13655C3.75371 5.25109 4.53416 4.51074 5.44931 3.97157C6.36445 3.43241 7.3903 3.10857 8.44914 3.0246C9.50798 2.94062 10.572 3.09871 11.5607 3.48688C12.5494 3.87505 13.4368 4.48313 14.1557 5.26506C14.8746 6.04698 15.4061 6.98225 15.71 8.00002H17.5C18.4655 7.99991 19.4054 8.31034 20.181 8.88546C20.9565 9.46058 21.5265 10.2699 21.8067 11.1938C22.087 12.1178 22.0627 13.1074 21.7373 14.0164C21.412 14.9254 20.8028 15.7057 20 16.242M17 18L16 20M12 20L11 22M12.5 10.5L10.75 13.75H13.75L12 17M8 18L7 20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingLeveedAreasIcon = ({
  className,
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M22 19H9L7.77974 14.7291M2 5H5L6.33918 9.68712M22 14.4167C21.4991 14.6176 20.9104 14.7889 20.2088 14.9151C16.4204 15.5968 14.0117 13.0884 10.8522 13.6569C9.63397 13.8761 8.59374 14.2915 7.77974 14.7291M22 8.41674C21.4991 8.61761 20.9104 8.78887 20.2088 8.91512C16.4204 9.59677 14.0117 7.08843 10.8522 7.65693C8.71011 8.04237 7.11837 9.03434 6.33918 9.68712M6.33918 9.68712L7.77974 14.7291"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingTsunamiIcon = ({
  className,
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M2 7.26282C3.8208 4.92801 9.3088 1.12697 15.2 4.07537C7.7696 3.88412 7.776 12.8409 16 12.8409C18.848 12.8409 20.7312 12.1556 21.9648 11.3045M22 15.672C21.3376 16.1102 19.352 16.99 16.704 16.99C13.392 16.99 11.2864 14.3524 7.3152 14.3524C4.1376 14.3524 2.9952 15.4457 2 16.1931M22 19.6804C21.3376 20.1203 19.352 21 16.704 21C11.76 21 11.272 18.3608 7.1712 18.3608C4.5744 18.3608 3.1712 19.4605 2.4352 20.4024"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingCrimeIcon = ({
  className,
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9.5 12.4678C8.89752 12.1684 8.21842 12 7.5 12C5.01472 12 3 14.0147 3 16.5C3 18.9853 5.01472 21 7.5 21C9.98528 21 12 18.9853 12 16.5C12 14.7331 10.9817 13.2041 9.5 12.4678ZM9.5 12.4678V11.5C9.5 10.9477 9.05228 10.5 8.5 10.5H7.5M5.5 12.5V11.5C5.5 10.9477 5.94772 10.5 6.5 10.5H7.5M7.5 10.5V9.62498C7.5 7.96813 8.84315 6.62498 10.5 6.62498H11.9534M14.6575 5.87681C14.097 6.24887 13.6116 6.75281 13.2524 7.37498C12.0098 9.5273 12.7472 12.2795 14.8995 13.5221C17.0518 14.7647 19.804 14.0273 21.0466 11.875C22.2893 9.72266 21.5518 6.97051 19.3995 5.72787C17.8694 4.84444 16.0361 4.96178 14.6575 5.87681ZM14.6575 5.87681L13.8194 5.39293C13.3411 5.11679 12.7295 5.28066 12.4534 5.75896L11.9534 6.62498M12.6854 9.35703L11.8194 8.85703C11.3411 8.58089 11.1772 7.9693 11.4534 7.49101L11.9534 6.62498"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingListExpandIcon = ({
  className,
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M11 6H21M11 12H21M11 18H21M8 16.5L5.5 19L3 16.5M8 7.5L5.5 5L3 7.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingListCollapseIcon = ({
  className,
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M11 6H21M11 12H21M11 18H21M8 19L5.5 16.5L3 19M8 5L5.5 7.5L3 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingCsvIcon = ({ className, size = 24, ...props }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3 4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V4Z"
        fill="#B61DCB"
      />
      <path
        d="M9.73438 8.73438C9.88082 8.58793 10.1192 8.58793 10.2656 8.73438C10.4121 8.88082 10.4121 9.11918 10.2656 9.26563L7.53125 12L10.2656 14.7344C10.4121 14.8808 10.4121 15.1192 10.2656 15.2656C10.1192 15.4121 9.88082 15.4121 9.73438 15.2656L6.73438 12.2656C6.58793 12.1192 6.58793 11.8808 6.73438 11.7344L9.73438 8.73438ZM13.7344 8.73438C13.8808 8.58793 14.1192 8.58793 14.2656 8.73438L17.2656 11.7344C17.4121 11.8808 17.4121 12.1192 17.2656 12.2656L14.2656 15.2656C14.1192 15.4121 13.8808 15.4121 13.7344 15.2656C13.5879 15.1192 13.5879 14.8808 13.7344 14.7344L16.4688 12L13.7344 9.26563C13.5879 9.11918 13.5879 8.88082 13.7344 8.73438Z"
        fill="white"
      />
    </svg>
  );
};

export const PingEmailIcon = ({
  className,
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clip-path="url(#clip0_673_2066)">
        <path
          d="M16.1744 3.74536L4.09243 11.4037L3.05341 9.76447V8.35197C3.05341 7.83773 3.31381 7.35844 3.74527 7.07857L10.7685 2.52131C11.8385 1.82698 13.2167 1.82684 14.2868 2.52103L16.1744 3.74536Z"
          fill="url(#paint0_linear_673_2066)"
        />
        <path
          d="M14.1786 2.45401C14.2149 2.47553 14.2509 2.49801 14.2867 2.52117L19.7678 6.07655L6.17749 14.691L4.09204 11.4009L14.0661 5.06658C15.0108 4.46655 15.0522 3.11682 14.1786 2.45401Z"
          fill="url(#paint1_linear_673_2066)"
        />
        <path
          d="M14.1786 2.45401C14.2149 2.47553 14.2509 2.49801 14.2867 2.52117L19.7678 6.07655L6.17749 14.691L4.09204 11.4009L14.0661 5.06658C15.0108 4.46655 15.0522 3.11682 14.1786 2.45401Z"
          fill="url(#paint2_linear_673_2066)"
        />
        <path
          d="M11.5997 16.3359L6.17761 14.6911L17.7057 7.38353C18.6766 6.76815 18.6742 5.35071 17.7011 4.73875L17.6491 4.70613L17.7986 4.79906L21.3072 7.07502C21.7387 7.35489 21.9992 7.83431 21.9992 8.34868V9.71569L11.5997 16.3359Z"
          fill="url(#paint3_linear_673_2066)"
        />
        <path
          d="M11.5997 16.3359L6.17761 14.6911L17.7057 7.38353C18.6766 6.76815 18.6742 5.35071 17.7011 4.73875L17.6491 4.70613L17.7986 4.79906L21.3072 7.07502C21.7387 7.35489 21.9992 7.83431 21.9992 8.34868V9.71569L11.5997 16.3359Z"
          fill="url(#paint4_linear_673_2066)"
        />
        <path
          d="M14.2868 2.52103C13.2167 1.82684 11.8385 1.82698 10.7683 2.52131L3.74527 7.07857C3.31381 7.35844 3.05341 7.83773 3.05341 8.35197V8.42104C3.0704 8.93734 3.34205 9.41306 3.7809 9.68978L12.5135 15.1952L21.2681 9.69814C21.7228 9.41265 21.9987 8.91349 21.9987 8.37664V9.71582L21.999 8.34868C21.999 7.8343 21.7385 7.35502 21.307 7.07501L14.2868 2.52103Z"
          fill="url(#paint5_radial_673_2066)"
        />
        <path
          d="M10.974 20.9344H18.7088C20.5255 20.9344 21.9982 19.4618 21.9982 17.6451V8.37663C21.9982 8.91348 21.7223 9.41264 21.2677 9.69813L9.7626 16.9221C9.14201 17.3119 8.76538 17.9932 8.76538 18.726C8.76552 19.9457 9.75424 20.9344 10.974 20.9344Z"
          fill="url(#paint6_linear_673_2066)"
        />
        <path
          d="M10.974 20.9344H18.7088C20.5255 20.9344 21.9982 19.4618 21.9982 17.6451V8.37663C21.9982 8.91348 21.7223 9.41264 21.2677 9.69813L9.7626 16.9221C9.14201 17.3119 8.76538 17.9932 8.76538 18.726C8.76552 19.9457 9.75424 20.9344 10.974 20.9344Z"
          fill="url(#paint7_radial_673_2066)"
        />
        <path
          d="M10.974 20.9344H18.7088C20.5255 20.9344 21.9982 19.4618 21.9982 17.6451V8.37663C21.9982 8.91348 21.7223 9.41264 21.2677 9.69813L9.7626 16.9221C9.14201 17.3119 8.76538 17.9932 8.76538 18.726C8.76552 19.9457 9.75424 20.9344 10.974 20.9344Z"
          fill="url(#paint8_radial_673_2066)"
        />
        <path
          d="M14.119 20.9339H6.34154C4.52486 20.9339 3.05219 19.4612 3.05219 17.6445V8.36978C3.05219 8.90567 3.32712 9.40401 3.78037 9.68977L15.2741 16.9358C15.9033 17.3325 16.2849 18.0245 16.2849 18.7683C16.2847 19.9644 15.3151 20.9339 14.119 20.9339Z"
          fill="url(#paint9_radial_673_2066)"
        />
        <path
          d="M14.119 20.9339H6.34154C4.52486 20.9339 3.05219 19.4612 3.05219 17.6445V8.36978C3.05219 8.90567 3.32712 9.40401 3.78037 9.68977L15.2741 16.9358C15.9033 17.3325 16.2849 18.0245 16.2849 18.7683C16.2847 19.9644 15.3151 20.9339 14.119 20.9339Z"
          fill="url(#paint10_linear_673_2066)"
        />
        <path
          d="M3.71047 10.933H8.71029C9.65502 10.933 10.4208 11.6987 10.4208 12.6435V17.6433C10.4208 18.588 9.65502 19.3538 8.71029 19.3538H3.71047C2.76574 19.3538 2 18.588 2 17.6433V12.6435C2 11.6987 2.76574 10.933 3.71047 10.933Z"
          fill="url(#paint11_radial_673_2066)"
        />
        <path
          d="M3.71047 10.933H8.71029C9.65502 10.933 10.4208 11.6987 10.4208 12.6435V17.6433C10.4208 18.588 9.65502 19.3538 8.71029 19.3538H3.71047C2.76574 19.3538 2 18.588 2 17.6433V12.6435C2 11.6987 2.76574 10.933 3.71047 10.933Z"
          fill="url(#paint12_radial_673_2066)"
        />
        <path
          d="M6.18886 17.5644C5.49248 17.5644 4.92095 17.3464 4.47401 16.9109C4.02707 16.4753 3.80353 15.9068 3.80353 15.2055C3.80353 14.4648 4.03036 13.8659 4.48401 13.4084C4.93781 12.951 5.53181 12.7224 6.2663 12.7224C6.96035 12.7224 7.52516 12.9413 7.96087 13.3791C8.3989 13.8168 8.61791 14.3941 8.61791 15.1106C8.61791 15.8469 8.39095 16.4404 7.93729 16.8913C7.48583 17.34 6.90306 17.5644 6.18886 17.5644ZM6.20901 16.6398C6.58852 16.6398 6.89402 16.5101 7.12537 16.2509C7.35672 15.9918 7.4724 15.6312 7.4724 15.1694C7.4724 14.6881 7.36001 14.3135 7.13551 14.0456C6.91087 13.7776 6.611 13.6437 6.23601 13.6437C5.84965 13.6437 5.53853 13.782 5.30279 14.0586C5.06692 14.3331 4.94905 14.6969 4.94905 15.1498C4.94905 15.6095 5.06692 15.9733 5.30279 16.2411C5.53853 16.5068 5.8406 16.6398 6.20901 16.6398Z"
          fill="white"
        />
        <path
          d="M6.18696 17.6292C5.49331 17.6292 4.92384 17.4055 4.47855 16.958C4.03339 16.5105 3.81067 15.9265 3.81067 15.2062C3.81067 14.4454 4.03668 13.8301 4.48869 13.3603C4.9407 12.8903 5.53251 12.6554 6.26412 12.6554C6.95543 12.6554 7.51819 12.8803 7.95224 13.33C8.38863 13.7798 8.60669 14.3727 8.60669 15.1089C8.60669 15.865 8.38068 16.4748 7.92881 16.9379C7.47899 17.3988 6.89842 17.6292 6.18696 17.6292ZM6.20697 16.6795C6.58511 16.6795 6.88951 16.5463 7.1199 16.2801C7.35043 16.0138 7.46556 15.6435 7.46556 15.1692C7.46556 14.6747 7.35372 14.2899 7.13004 14.0147C6.90623 13.7395 6.60758 13.6019 6.23397 13.6019C5.84897 13.6019 5.53909 13.7439 5.30417 14.0282C5.06926 14.31 4.9518 14.6837 4.9518 15.149C4.9518 15.6212 5.06926 15.9948 5.30417 16.27C5.53909 16.543 5.84007 16.6795 6.20697 16.6795Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_673_2066"
          x1="5.15203"
          y1="10.5988"
          x2="16.1743"
          y2="3.76219"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#20A7FA" />
          <stop offset="0.4" stop-color="#3BD5FF" />
          <stop offset="1" stop-color="#C4B0FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_673_2066"
          x1="8.94566"
          y1="12.9301"
          x2="15.0818"
          y2="3.10474"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#165AD9" />
          <stop offset="0.5008" stop-color="#1880E5" />
          <stop offset="1" stop-color="#8587FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_673_2066"
          x1="13.4209"
          y1="13.0637"
          x2="6.60843"
          y2="7.51277"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.236946" stop-color="#448AFF" stop-opacity="0" />
          <stop offset="0.792113" stop-color="#0032B1" stop-opacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_673_2066"
          x1="12.554"
          y1="15.2012"
          x2="23.3203"
          y2="8.31085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1A43A6" />
          <stop offset="0.492267" stop-color="#2052CB" />
          <stop offset="1" stop-color="#5F20CB" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_673_2066"
          x1="15.5932"
          y1="14.7894"
          x2="9.05106"
          y2="9.12824"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0045B9" stop-opacity="0" />
          <stop offset="0.669859" stop-color="#0D1F69" stop-opacity="0.2" />
        </linearGradient>
        <radialGradient
          id="paint5_radial_673_2066"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.5269 2.41641) rotate(-90) scale(14.2114 15.3817)"
        >
          <stop offset="0.568182" stop-color="#275FF0" stop-opacity="0" />
          <stop offset="0.992424" stop-color="#002177" />
        </radialGradient>
        <linearGradient
          id="paint6_linear_673_2066"
          x1="21.9982"
          y1="14.5871"
          x2="12.4479"
          y2="14.5871"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4DC4FF" />
          <stop offset="0.196145" stop-color="#0FAFFF" />
        </linearGradient>
        <radialGradient
          id="paint7_radial_673_2066"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.68 18.781) rotate(-45) scale(6.09031)"
        >
          <stop offset="0.259477" stop-color="#0060D1" stop-opacity="0.4" />
          <stop offset="0.908166" stop-color="#0383F1" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_673_2066"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.49008 23.2863) rotate(-52.6577) scale(20.6737 18.6943)"
        >
          <stop offset="0.732317" stop-color="#F4A7F7" stop-opacity="0" />
          <stop offset="1" stop-color="#F4A7F7" stop-opacity="0.501961" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_673_2066"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.66858 13.3181) rotate(123.339) scale(10.9079 28.3074)"
        >
          <stop stop-color="#49DEFF" />
          <stop offset="0.724349" stop-color="#29C3FF" />
        </radialGradient>
        <linearGradient
          id="paint10_linear_673_2066"
          x1="1.71452"
          y1="18.7603"
          x2="10.9097"
          y2="18.7536"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.205882" stop-color="#6CE0FF" />
          <stop offset="0.535" stop-color="#50D5FF" stop-opacity="0" />
        </linearGradient>
        <radialGradient
          id="paint11_radial_673_2066"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.96995 11.2569) rotate(46.9242) scale(11.0848)"
        >
          <stop offset="0.038877" stop-color="#0091FF" />
          <stop offset="0.919119" stop-color="#183DAD" />
        </radialGradient>
        <radialGradient
          id="paint12_radial_673_2066"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.21038 16.0612) rotate(90) scale(5.89453 6.79913)"
        >
          <stop offset="0.557796" stop-color="#0FA5F7" stop-opacity="0" />
          <stop offset="1" stop-color="#74C6FF" stop-opacity="0.501961" />
        </radialGradient>
        <clipPath id="clip0_673_2066">
          <rect
            width="20"
            height="18.9351"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PingExcelIcon = ({
  className,
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M5.21432 8.38875C5.21432 7.00797 6.30821 5.88875 7.65744 5.88875H21.5005V20.3331C21.5005 21.2536 20.7712 22 19.8718 22H8.47125C6.67259 22 5.21432 20.5077 5.21432 18.6669V8.38875Z"
        fill="url(#paint0_radial_673_2068)"
      />
      <path
        d="M5.21432 8.38875C5.21432 7.00797 6.30821 5.88875 7.65744 5.88875H21.5005V20.3331C21.5005 21.2536 20.7712 22 19.8718 22H8.47125C6.67259 22 5.21432 20.5077 5.21432 18.6669V8.38875Z"
        fill="url(#paint1_radial_673_2068)"
      />
      <path
        d="M5.21432 11.1669C5.21432 9.78594 6.30821 8.66688 7.65744 8.66688H14.986C14.0865 8.66688 13.3573 9.41313 13.3573 10.3336V13.6669C13.3573 14.5872 12.6283 15.3336 11.7286 15.3336H8.4717C6.67289 15.3336 5.21478 16.8259 5.21478 18.6669V11.1669H5.21432Z"
        fill="url(#paint2_linear_673_2068)"
      />
      <path
        d="M5.21432 11.1669C5.21432 9.78594 6.30821 8.66688 7.65744 8.66688H14.986C14.0865 8.66688 13.3573 9.41313 13.3573 10.3336V13.6669C13.3573 14.5872 12.6283 15.3336 11.7286 15.3336H8.4717C6.67289 15.3336 5.21478 16.8259 5.21478 18.6669V11.1669H5.21432Z"
        fill="url(#paint3_linear_673_2068)"
      />
      <path
        d="M5.21432 5.33312C5.21432 3.49234 6.67259 2 8.47125 2H14.9857V8.66687H8.47125C6.67259 8.66687 5.21432 10.1592 5.21432 12V5.33312Z"
        fill="url(#paint4_linear_673_2068)"
      />
      <path
        d="M5.21432 5.33312C5.21432 3.49234 6.67259 2 8.47125 2H14.9857V8.66687H8.47125C6.67259 8.66687 5.21432 10.1592 5.21432 12V5.33312Z"
        fill="url(#paint5_radial_673_2068)"
      />
      <path
        d="M5.21432 5.33312C5.21432 3.49234 6.67259 2 8.47125 2H14.9857V8.66687H8.47125C6.67259 8.66687 5.21432 10.1592 5.21432 12V5.33312Z"
        fill="url(#paint6_linear_673_2068)"
      />
      <path
        d="M14.9857 2H19.8713C20.7708 2 21.5 2.74609 21.5 3.66641V7.00047C21.5 7.92078 20.7708 8.66687 19.8713 8.66687H14.9857C14.0862 8.66687 13.357 7.92078 13.357 7.00047V3.66641C13.357 2.74609 14.0862 2 14.9857 2Z"
        fill="url(#paint7_radial_673_2068)"
      />
      <path
        d="M4.2643 11.4444H9.42128C10.3957 11.4444 11.1857 12.2527 11.1857 13.2495V18.528C11.1857 19.525 10.3957 20.3331 9.42128 20.3331H4.2643C3.28999 20.3331 2.5 19.525 2.5 18.528V13.2495C2.5 12.2527 3.28999 11.4444 4.2643 11.4444Z"
        fill="url(#paint8_radial_673_2068)"
      />
      <path
        d="M4.2643 11.4444H9.42128C10.3957 11.4444 11.1857 12.2527 11.1857 13.2495V18.528C11.1857 19.525 10.3957 20.3331 9.42128 20.3331H4.2643C3.28999 20.3331 2.5 19.525 2.5 18.528V13.2495C2.5 12.2527 3.28999 11.4444 4.2643 11.4444Z"
        fill="url(#paint9_radial_673_2068)"
      />
      <path
        d="M9.12578 18.4284H7.78679L6.94625 16.8095C6.91617 16.7528 6.89311 16.708 6.87707 16.6748C6.86333 16.6395 6.84806 16.5992 6.83202 16.5544H6.81843C6.79766 16.6112 6.77812 16.6572 6.75979 16.6923C6.74131 16.728 6.71947 16.7716 6.69412 16.8236L5.82228 18.428H4.55949L6.07487 15.8848L4.66349 13.3487H5.98492L6.732 14.7941C6.76208 14.8531 6.78758 14.9052 6.8082 14.95C6.83126 14.9923 6.85432 15.0431 6.87738 15.1023H6.89112C6.92319 15.0341 6.94854 14.9795 6.96733 14.9395C6.9881 14.8995 7.01589 14.8464 7.05025 14.7805L7.82512 13.3495H9.08439L7.65225 15.8469L9.12609 18.4287L9.12578 18.4284Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_673_2068"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-15.3817 -16.5611 -12.5543 12.212 21.5479 23.2718)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.06" stop-color="#379539" />
          <stop offset="0.42" stop-color="#297C2D" />
          <stop offset="0.7" stop-color="#15561C" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_673_2068"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-6.50333 -6.43461 -4.8647 5.14933 10.1404 11.7484)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#073B10" stop-opacity="0.698039" />
          <stop offset="0.99" stop-color="#084A13" stop-opacity="0" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_673_2068"
          x1="5.21434"
          y1="13.6668"
          x2="12.6974"
          y2="13.6668"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#52D17C" />
          <stop offset="0.33" stop-color="#4AA647" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_673_2068"
          x1="10.1"
          y1="8.6668"
          x2="10.1"
          y2="15.6128"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#29852F" stop-opacity="0.301961" />
          <stop offset="0.5" stop-color="#4AA647" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_673_2068"
          x1="5.64672"
          y1="10.1912"
          x2="14.8529"
          y2="2.38706"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#66D052" />
          <stop offset="1" stop-color="#85E972" />
        </linearGradient>
        <radialGradient
          id="paint5_radial_673_2068"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.7394 6.12434) rotate(-180) scale(4.89808 10.6064)"
        >
          <stop offset="0.29" stop-color="#4EB43B" />
          <stop offset="1" stop-color="#72CC61" stop-opacity="0" />
        </radialGradient>
        <linearGradient
          id="paint6_linear_673_2068"
          x1="9.61952"
          y1="7"
          x2="5.21434"
          y2="7"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stop-color="#C0E075" stop-opacity="0" />
          <stop offset="1" stop-color="#D1EB95" />
        </linearGradient>
        <radialGradient
          id="paint7_radial_673_2068"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-9.1813 -7.60162 7.40747 -9.36933 22.6465 9.68391)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.44" stop-color="#79E96D" />
          <stop offset="1" stop-color="#D0EB76" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_673_2068"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(8.68403 8.88824 24.7302 -25.3065 2.75519 11.4921)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#20A85E" />
          <stop offset="0.94" stop-color="#09442A" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_673_2068"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.94198 16.7782) rotate(90) scale(6.22272 7.00502)"
        >
          <stop offset="0.58" stop-color="#33A662" stop-opacity="0" />
          <stop offset="0.97" stop-color="#98F0B0" stop-opacity="0.301961" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const PingJsonIcon = ({ className, size = 24, ...props }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3 4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V4Z"
        fill="#6920E6"
      />
      <path
        d="M9.74957 7.5C9.35174 7.5 8.97021 7.65804 8.68891 7.93934C8.4076 8.22064 8.24957 8.60218 8.24957 9V10.5038C8.24957 10.9013 8.24357 11.0992 8.18207 11.2515C8.13557 11.3685 8.03657 11.4998 7.70657 11.664C7.64416 11.6951 7.59167 11.743 7.55497 11.8023C7.51828 11.8616 7.49884 11.9299 7.49884 11.9996C7.49884 12.0693 7.51828 12.1377 7.55497 12.197C7.59167 12.2563 7.64416 12.3041 7.70657 12.3352C8.03657 12.5002 8.13557 12.6315 8.18282 12.7485C8.24357 12.9015 8.24957 13.101 8.24957 13.5V15C8.24957 15.3978 8.4076 15.7794 8.68891 16.0607C8.97021 16.342 9.35174 16.5 9.74957 16.5C9.84902 16.5 9.9444 16.4605 10.0147 16.3902C10.0851 16.3198 10.1246 16.2245 10.1246 16.125C10.1246 16.0255 10.0851 15.9302 10.0147 15.8598C9.9444 15.7895 9.84902 15.75 9.74957 15.75C9.55065 15.75 9.35989 15.671 9.21924 15.5303C9.07858 15.3897 8.99957 15.1989 8.99957 15V13.4557C8.99957 13.119 8.99957 12.7733 8.87957 12.4703C8.80677 12.2904 8.69391 12.1296 8.54957 12C8.69657 11.865 8.80607 11.712 8.87957 11.5305C8.99957 11.2283 8.99957 10.8825 8.99957 10.5473V9C8.99957 8.80109 9.07858 8.61032 9.21924 8.46967C9.35989 8.32902 9.55065 8.25 9.74957 8.25C9.84902 8.25 9.9444 8.21049 10.0147 8.14016C10.0851 8.06984 10.1246 7.97446 10.1246 7.875C10.1246 7.77554 10.0851 7.68016 10.0147 7.60984C9.9444 7.53951 9.84902 7.5 9.74957 7.5ZM14.2496 7.5C14.6474 7.5 15.0289 7.65804 15.3102 7.93934C15.5915 8.22064 15.7496 8.60218 15.7496 9V10.5038C15.7496 10.9013 15.7556 11.0992 15.8171 11.2515C15.8636 11.3685 15.9626 11.4998 16.2926 11.664C16.355 11.6951 16.4075 11.743 16.4442 11.8023C16.4809 11.8616 16.5003 11.9299 16.5003 11.9996C16.5003 12.0693 16.4809 12.1377 16.4442 12.197C16.4075 12.2563 16.355 12.3041 16.2926 12.3352C15.9626 12.5002 15.8636 12.6315 15.8163 12.7485C15.7556 12.9015 15.7496 13.101 15.7496 13.5V15C15.7496 15.3978 15.5915 15.7794 15.3102 16.0607C15.0289 16.342 14.6474 16.5 14.2496 16.5C14.1501 16.5 14.0547 16.4605 13.9844 16.3902C13.9141 16.3198 13.8746 16.2245 13.8746 16.125C13.8746 16.0255 13.9141 15.9302 13.9844 15.8598C14.0547 15.7895 14.1501 15.75 14.2496 15.75C14.4485 15.75 14.6392 15.671 14.7799 15.5303C14.9205 15.3897 14.9996 15.1989 14.9996 15V13.4557C14.9996 13.119 14.9996 12.7733 15.1196 12.4703C15.1924 12.2904 15.3052 12.1296 15.4496 12C15.3053 11.8706 15.1925 11.71 15.1196 11.5305C14.9996 11.2283 14.9996 10.8825 14.9996 10.5473V9C14.9996 8.80109 14.9205 8.61032 14.7799 8.46967C14.6392 8.32902 14.4485 8.25 14.2496 8.25C14.1501 8.25 14.0547 8.21049 13.9844 8.14016C13.9141 8.06984 13.8746 7.97446 13.8746 7.875C13.8746 7.77554 13.9141 7.68016 13.9844 7.60984C14.0547 7.53951 14.1501 7.5 14.2496 7.5Z"
        fill="white"
      />
    </svg>
  );
};

export const PingMiscIcon = ({ className, size = 24, ...props }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3 4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V4Z"
        fill="#1387F3"
      />
      <path
        d="M13.5498 14.6252C13.7569 14.6252 13.9248 14.7931 13.9248 15.0002C13.9247 15.2072 13.7568 15.3752 13.5498 15.3752H7.5C7.29297 15.3752 7.12513 15.2072 7.125 15.0002C7.125 14.7931 7.29289 14.6252 7.5 14.6252H13.5498ZM16.5 11.675C16.7071 11.675 16.875 11.8429 16.875 12.05C16.875 12.2572 16.7071 12.425 16.5 12.425H7.5C7.29289 12.425 7.125 12.2572 7.125 12.05C7.125 11.8429 7.29289 11.675 7.5 11.675H16.5ZM14.5 8.67505C14.7071 8.67505 14.875 8.84294 14.875 9.05005C14.875 9.25716 14.7071 9.42505 14.5 9.42505H7.5C7.29289 9.42505 7.125 9.25716 7.125 9.05005C7.125 8.84294 7.29289 8.67505 7.5 8.67505H14.5Z"
        fill="white"
      />
    </svg>
  );
};

export const PingPdfIcon = ({ className, size = 24, ...props }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3 4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V4Z"
        fill="#C4103A"
      />
      <path
        d="M11.4689 6.76013C11.6008 6.74985 11.7227 6.78443 11.8107 6.82166C11.9104 6.86386 12.0073 6.92419 12.0929 6.99255C12.2492 7.11745 12.4365 7.32621 12.4826 7.59021L12.5334 7.93494C12.6432 8.91991 12.4478 9.842 12.1467 10.7513C12.3876 11.1608 12.655 11.5764 12.9338 11.9896L13.2922 12.515L13.2941 12.517C13.3722 12.6319 13.4489 12.7372 13.5236 12.8344C14.4885 12.659 15.3927 12.5902 16.0549 12.6986C16.4061 12.7561 16.7488 12.8725 16.9816 13.1058C17.2424 13.3675 17.3082 13.7167 17.2072 14.0853C17.1121 14.4342 16.7957 14.609 16.5646 14.6908C16.3138 14.7795 16.0282 14.8112 15.7961 14.7972L15.7931 14.7963C15.23 14.7577 14.6953 14.6809 14.172 14.4047C13.8459 14.2324 13.5385 13.9901 13.2326 13.6556C12.3818 13.8353 11.4746 14.0979 10.6261 14.4135C10.0459 15.4614 9.3175 16.3515 8.37224 17.0199C8.35684 17.0352 8.34074 17.0501 8.32244 17.0629C8.09914 17.2179 7.81156 17.2682 7.56462 17.2435C7.32641 17.2197 7.0203 17.1116 6.86052 16.8265L6.85955 16.8275C6.67065 16.4933 6.76939 16.133 6.88982 15.891C7.01587 15.6379 7.21316 15.4104 7.39763 15.2582L7.40056 15.2552H7.40154C8.05529 14.7299 9.01261 14.2388 10.051 13.8304C10.0666 13.8243 10.0822 13.818 10.0978 13.8119C10.3109 13.4014 10.5055 12.9625 10.6828 12.4965L10.6838 12.4945C10.9129 11.9014 11.1349 11.3526 11.3234 10.8275C11.3148 10.8121 11.3055 10.797 11.297 10.7816C10.8992 10.0596 10.5823 9.31912 10.4826 8.61169L10.4552 8.39001C10.4313 8.14703 10.4245 7.84775 10.4943 7.57458C10.5425 7.38652 10.6323 7.18613 10.801 7.02771C10.9705 6.86856 11.1909 6.78017 11.4484 6.76111V6.76013C11.4507 6.75987 11.453 6.76036 11.4552 6.76013C11.4598 6.75982 11.4643 6.75845 11.4689 6.75818V6.76013ZM9.42107 14.9183C8.79747 15.2127 8.26164 15.5265 7.87126 15.8402L7.87029 15.8392C7.75591 15.9345 7.63263 16.0814 7.56072 16.226C7.5217 16.3045 7.50816 16.3598 7.50505 16.3969L7.51287 16.4584L7.51384 16.4603C7.50443 16.4434 7.52256 16.4857 7.63982 16.4974C7.73575 16.507 7.8226 16.4836 7.87419 16.4564C7.87864 16.453 7.88324 16.4499 7.88787 16.4467C8.48043 16.0374 8.98409 15.523 9.42107 14.9183ZM15.9338 13.4388C15.4926 13.3666 14.8713 13.3872 14.1476 13.4906C14.2754 13.5934 14.3991 13.6763 14.5226 13.7416C14.9049 13.9434 15.3122 14.0118 15.8439 14.0482H15.8429C15.9853 14.0565 16.1678 14.0353 16.3136 13.9838C16.4775 13.9258 16.4892 13.8715 16.4845 13.8881C16.5274 13.7323 16.4898 13.6757 16.4504 13.6361C16.3826 13.5681 16.2276 13.487 15.9338 13.4388ZM11.383 12.7621L11.384 12.7631C11.2943 12.9987 11.199 13.2292 11.0998 13.4545C11.6371 13.2791 12.1844 13.1258 12.7179 13.0013C12.7034 12.9803 12.6876 12.9594 12.673 12.9379V12.9369C12.3861 12.5199 12.0944 12.088 11.8195 11.6537C11.6769 12.0216 11.5268 12.3899 11.383 12.7621ZM11.5051 7.5072C11.3945 7.51507 11.3429 7.54805 11.3146 7.57458C11.2805 7.60659 11.2459 7.66339 11.2209 7.76111C11.1811 7.91679 11.1826 8.11288 11.2013 8.30896L11.2248 8.5033V8.50525C11.281 8.9061 11.4293 9.34174 11.6427 9.80408C11.8129 9.11626 11.8754 8.4427 11.7443 7.72498L11.7433 7.71912C11.7421 7.71549 11.7365 7.70089 11.7189 7.67615C11.6968 7.64504 11.6639 7.61019 11.6242 7.57849C11.5843 7.54666 11.5459 7.524 11.5177 7.51208C11.5126 7.5099 11.5083 7.50834 11.5051 7.5072Z"
        fill="white"
      />
    </svg>
  );
};

export const PingPowerpointIcon = ({
  className,
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M22.6649 12C22.6649 6.47708 18.1882 2 12.6658 2C7.14348 2 2.66667 6.47708 2.66667 12C2.66667 17.5229 7.14348 22 12.6658 22C18.1882 22 22.6649 17.5229 22.6649 12Z"
        fill="url(#paint0_linear_673_2063)"
      />
      <path
        d="M22.6649 12C22.6649 6.47708 18.1882 2 12.6658 2C7.14348 2 2.66667 6.47708 2.66667 12C2.66667 17.5229 7.14348 22 12.6658 22C18.1882 22 22.6649 17.5229 22.6649 12Z"
        fill="url(#paint1_radial_673_2063)"
      />
      <path
        d="M22.6649 12C22.6649 6.47708 18.1882 2 12.6658 2C7.14348 2 2.66667 6.47708 2.66667 12C2.66667 17.5229 7.14348 22 12.6658 22C18.1882 22 22.6649 17.5229 22.6649 12Z"
        fill="url(#paint2_radial_673_2063)"
      />
      <path
        d="M12.6672 2C18.1894 2.00014 22.6661 6.47722 22.6661 12C22.6661 13.8372 22.1697 15.5581 21.3053 17.0375L21.4678 16.6776C22.4574 14.4804 20.8489 11.994 18.439 11.9958L14.4593 11.9989C13.47 11.9997 12.6672 11.1976 12.6672 10.2083V6.22139C12.6671 3.81056 10.1779 2.20389 7.98125 3.19681L7.66139 3.34167C9.13361 2.48861 10.8433 2 12.6672 2Z"
        fill="url(#paint3_linear_673_2063)"
      />
      <path
        d="M12.6672 2C18.1894 2.00014 22.6661 6.47722 22.6661 12C22.6661 13.8372 22.1697 15.5581 21.3053 17.0375L21.4678 16.6776C22.4574 14.4804 20.8489 11.994 18.439 11.9958L14.4593 11.9989C13.47 11.9997 12.6672 11.1976 12.6672 10.2083V6.22139C12.6671 3.81056 10.1779 2.20389 7.98125 3.19681L7.66139 3.34167C9.13361 2.48861 10.8433 2 12.6672 2Z"
        fill="url(#paint4_radial_673_2063)"
      />
      <path
        d="M12.6672 2C18.1894 2.00014 22.6661 6.47722 22.6661 12C22.6661 13.8372 22.1697 15.5581 21.3053 17.0375L21.4678 16.6776C22.4574 14.4804 20.8489 11.994 18.439 11.9958L14.4593 11.9989C13.47 11.9997 12.6672 11.1976 12.6672 10.2083V6.22139C12.6671 3.81056 10.1779 2.20389 7.98125 3.19681L7.66139 3.34167C9.13361 2.48861 10.8433 2 12.6672 2Z"
        fill="url(#paint5_radial_673_2063)"
      />
      <path
        d="M12.6672 2C18.1894 2.00014 22.6661 6.47722 22.6661 12C22.6661 13.8372 22.1697 15.5581 21.3053 17.0375L21.4678 16.6776C22.4574 14.4804 20.8489 11.994 18.439 11.9958L14.4593 11.9989C13.47 11.9997 12.6672 11.1976 12.6672 10.2083V6.22139C12.6671 3.81056 10.1779 2.20389 7.98125 3.19681L7.66139 3.34167C9.13361 2.48861 10.8433 2 12.6672 2Z"
        fill="url(#paint6_radial_673_2063)"
      />
      <path
        d="M12.6672 2C18.1894 2.00014 22.6661 6.47722 22.6661 12C22.6661 13.8372 22.1697 15.5581 21.3053 17.0375L21.4678 16.6776C22.4574 14.4804 20.8489 11.994 18.439 11.9958L14.4593 11.9989C13.47 11.9997 12.6672 11.1976 12.6672 10.2083V6.22139C12.6671 3.81056 10.1779 2.20389 7.98125 3.19681L7.66139 3.34167C9.13361 2.48861 10.8433 2 12.6672 2Z"
        fill="url(#paint7_radial_673_2063)"
      />
      <path
        d="M3.73333 11.4667H8.8C9.75736 11.4667 10.5333 12.2426 10.5333 13.2V18.2667C10.5333 19.224 9.75736 20 8.8 20H3.73333C2.77597 20 2 19.224 2 18.2667V13.2C2 12.2426 2.77597 11.4667 3.73333 11.4667Z"
        fill="url(#paint8_radial_673_2063)"
      />
      <path
        d="M3.73333 11.4667H8.8C9.75736 11.4667 10.5333 12.2426 10.5333 13.2V18.2667C10.5333 19.224 9.75736 20 8.8 20H3.73333C2.77597 20 2 19.224 2 18.2667V13.2C2 12.2426 2.77597 11.4667 3.73333 11.4667Z"
        fill="url(#paint9_radial_673_2063)"
      />
      <path
        d="M5.85042 16.5833V18.1714H4.75264V13.2951H6.44861C7.05583 13.2951 7.51806 13.4278 7.83528 13.6931C8.15486 13.9582 8.31458 14.3515 8.31458 14.8729C8.31458 15.4103 8.13556 15.8296 7.7775 16.1311C7.42181 16.4326 6.94361 16.5833 6.3432 16.5833H5.85042ZM5.85042 14.1385V15.74H6.30931C6.58111 15.74 6.79083 15.6687 6.93806 15.5258C7.08528 15.3831 7.15903 15.1779 7.15903 14.9104C7.15903 14.6633 7.08639 14.4729 6.94139 14.339C6.79861 14.2053 6.59361 14.1385 6.32625 14.1385H5.85042Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_673_2063"
          x1="11.6512"
          y1="1.36334"
          x2="-0.600736"
          y2="13.0842"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0582736" stop-color="#FF7F48" />
          <stop offset="1" stop-color="#E5495B" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_673_2063"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.6184 7.80304) rotate(135) scale(20.0775 33.7931)"
        >
          <stop offset="0.151523" stop-color="#AA1D2D" />
          <stop
            offset="0.380855"
            stop-color="#D12B18"
            stop-opacity="0.439216"
          />
          <stop offset="0.601996" stop-color="#FF3C00" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_673_2063"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-0.823489 20.1286) rotate(-25.2832) scale(19.0325 34.4801)"
        >
          <stop offset="0.4067" stop-color="#FF66FB" stop-opacity="0.501961" />
          <stop offset="1" stop-color="#EA3D01" stop-opacity="0" />
        </radialGradient>
        <linearGradient
          id="paint3_linear_673_2063"
          x1="14.5596"
          y1="14.2252"
          x2="25.3221"
          y2="6.24837"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.310768" stop-color="#FF6E30" />
          <stop offset="0.634576" stop-color="#FFA05C" />
        </linearGradient>
        <radialGradient
          id="paint4_radial_673_2063"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.9869 13.1958) rotate(11.8349) scale(12.9275 12.3244)"
        >
          <stop offset="0.78593" stop-color="#FFA05C" stop-opacity="0" />
          <stop offset="0.904889" stop-color="#FFCE84" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_673_2063"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.0149 11.85) rotate(-33.1977) scale(13.0536 12.4833)"
        >
          <stop offset="0.295239" stop-color="#FF99E9" stop-opacity="0.8" />
          <stop offset="0.727968" stop-color="#FF99E9" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_673_2063"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.5491 13.3766) rotate(-48.864) scale(13.8981 12.6929)"
        >
          <stop stop-color="#FD6EF9" />
          <stop offset="0.637205" stop-color="#FF9944" />
          <stop offset="0.85186" stop-color="#FCC479" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_673_2063"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.6395 3.32159) rotate(98.3949) scale(7.07381 15.9869)"
        >
          <stop offset="0.144283" stop-color="#FF8D13" />
          <stop offset="0.537266" stop-color="#FF7F29" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_673_2063"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.99896 11.4667) rotate(45) scale(12.0679)"
        >
          <stop stop-color="#F8193E" />
          <stop offset="0.939062" stop-color="#920616" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_673_2063"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.2656 16.5867) rotate(90) scale(5.97333 6.8)"
        >
          <stop offset="0.575893" stop-color="#FFB055" stop-opacity="0" />
          <stop
            offset="0.973806"
            stop-color="#FFF2BE"
            stop-opacity="0.301961"
          />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const PingAlienIcon = ({
  className,
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16L3.54223 12.3383C1.93278 11.0162 1 9.04287 1 6.96005C1 3.11612 4.15607 0 8 0C11.8439 0 15 3.11612 15 6.96005C15 9.04287 14.0672 11.0162 12.4578 12.3383L8 16ZM3 6H5C6.10457 6 7 6.89543 7 8V9L3 7.5V6ZM11 6C9.89543 6 9 6.89543 9 8V9L13 7.5V6H11Z"
        fill={color}
      />
    </svg>
  );
};

export const PingSinkholeIcon = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 1.3,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g transform="translate(10, 6)">
        <ellipse
          cx="0"
          cy="0"
          rx="8.5"
          ry="3.8"
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
        />
        <ellipse
          cx="0"
          cy="1.5"
          rx="5.8"
          ry="2.6"
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
        />
        <ellipse
          cx="0"
          cy="2.8"
          rx="3.1"
          ry="1.4"
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
        />
        <ellipse cx="0" cy="3.7" rx="1.2" ry="0.7" fill={color} />
        <line
          x1="0"
          y1="4.4"
          x2="0"
          y2="10"
          stroke={color}
          strokeWidth={strokeWidth}
        />
        <path
          d="M-2 8L0 10.5L2 8"
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const PingDiamondWarningIcon = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9.09009 9.00008C9.32519 8.33175 9.78924 7.76819 10.4 7.40921C11.0108 7.05024 11.729 6.91902 12.4273 7.03879C13.1255 7.15857 13.7589 7.52161 14.2152 8.06361C14.6714 8.60561 14.9211 9.2916 14.9201 10.0001C14.9201 12.0001 11.9201 13.0001 11.9201 13.0001V13.8903M12 17H12.01M2.7 10.3C2.47595 10.5238 2.29821 10.7896 2.17694 11.0822C2.05567 11.3747 1.99326 11.6883 1.99326 12.005C1.99326 12.3217 2.05567 12.6353 2.17694 12.9278C2.29821 13.2204 2.47595 13.4862 2.7 13.71L10.29 21.3C10.5138 21.524 10.7796 21.7018 11.0722 21.8231C11.3647 21.9443 11.6783 22.0067 11.995 22.0067C12.3117 22.0067 12.6253 21.9443 12.9178 21.8231C13.2104 21.7018 13.4762 21.524 13.7 21.3L21.29 13.71C21.5141 13.4862 21.6918 13.2204 21.8131 12.9278C21.9343 12.6353 21.9967 12.3217 21.9967 12.005C21.9967 11.6883 21.9343 11.3747 21.8131 11.0822C21.6918 10.7896 21.5141 10.5238 21.29 10.3L13.7 2.71C13.4762 2.48594 13.2104 2.3082 12.9178 2.18694C12.6253 2.06567 12.3117 2.00325 11.995 2.00325C11.6783 2.00325 11.3647 2.06567 11.0722 2.18694C10.7796 2.3082 10.5138 2.48594 10.29 2.71L2.7 10.3Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingDiamondCheckIcon = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M8.99997 12L11 14L15 9.99998M2.7 10.3C2.47595 10.5238 2.29821 10.7896 2.17694 11.0822C2.05567 11.3747 1.99326 11.6883 1.99326 12.005C1.99326 12.3217 2.05567 12.6353 2.17694 12.9278C2.29821 13.2204 2.47595 13.4862 2.7 13.71L10.29 21.3C10.5138 21.524 10.7796 21.7018 11.0722 21.8231C11.3647 21.9443 11.6783 22.0067 11.995 22.0067C12.3117 22.0067 12.6253 21.9443 12.9178 21.8231C13.2104 21.7018 13.4762 21.524 13.7 21.3L21.29 13.71C21.5141 13.4862 21.6918 13.2204 21.8131 12.9278C21.9343 12.6353 21.9967 12.3217 21.9967 12.005C21.9967 11.6883 21.9343 11.3747 21.8131 11.0822C21.6918 10.7896 21.5141 10.5238 21.29 10.3L13.7 2.71C13.4762 2.48594 13.2104 2.3082 12.9178 2.18694C12.6253 2.06567 12.3117 2.00325 11.995 2.00325C11.6783 2.00325 11.3647 2.06567 11.0722 2.18694C10.7796 2.3082 10.5138 2.48594 10.29 2.71L2.7 10.3Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingDiamondXIcon = ({
  className,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M15 8.99998L8.99997 15M8.99997 8.99998L15 15M2.7 10.3C2.47595 10.5238 2.29821 10.7896 2.17694 11.0822C2.05567 11.3747 1.99326 11.6883 1.99326 12.005C1.99326 12.3217 2.05567 12.6353 2.17694 12.9278C2.29821 13.2204 2.47595 13.4862 2.7 13.71L10.29 21.3C10.5138 21.524 10.7796 21.7018 11.0722 21.8231C11.3647 21.9443 11.6783 22.0067 11.995 22.0067C12.3117 22.0067 12.6253 21.9443 12.9178 21.8231C13.2104 21.7018 13.4762 21.524 13.7 21.3L21.29 13.71C21.5141 13.4862 21.6918 13.2204 21.8131 12.9278C21.9343 12.6353 21.9967 12.3217 21.9967 12.005C21.9967 11.6883 21.9343 11.3747 21.8131 11.0822C21.6918 10.7896 21.5141 10.5238 21.29 10.3L13.7 2.71C13.4762 2.48594 13.2104 2.3082 12.9178 2.18694C12.6253 2.06567 12.3117 2.00325 11.995 2.00325C11.6783 2.00325 11.3647 2.06567 11.0722 2.18694C10.7796 2.3082 10.5138 2.48594 10.29 2.71L2.7 10.3Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PingFileEyeIcon = ({
  className,
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M7 1H3C2.73478 1 2.48043 1.10536 2.29289 1.29289C2.10536 1.48043 2 1.73479 2 2V3.5M7 1C7.15828 0.999745 7.31504 1.0308 7.46127 1.09139C7.60749 1.15197 7.74028 1.24088 7.852 1.353L9.646 3.147C9.75842 3.25876 9.84759 3.39167 9.90835 3.53808C9.96911 3.68449 10.0003 3.84149 10 4M7 1V3.5C7 3.63261 7.05268 3.75979 7.14645 3.85355C7.24022 3.94732 7.36739 4 7.5 4L10 4M10 4V10C10 10.2652 9.89464 10.5196 9.70711 10.7071C9.51957 10.8946 9.26522 11 9 11M0.770835 7.94913C0.743055 7.87429 0.743055 7.79197 0.770835 7.71713C1.0414 7.06108 1.50067 6.50014 2.09043 6.10543C2.68018 5.71071 3.37385 5.5 4.0835 5.5C4.79315 5.5 5.48683 5.71071 6.07658 6.10543C6.66633 6.50014 7.1256 7.06108 7.39617 7.71713C7.42395 7.79197 7.42395 7.87429 7.39617 7.94913C7.1256 8.60518 6.66633 9.16612 6.07658 9.56083C5.48683 9.95554 4.79315 10.1663 4.0835 10.1663C3.37385 10.1663 2.68018 9.95554 2.09043 9.56083C1.50067 9.16612 1.0414 8.60518 0.770835 7.94913ZM4.8335 7.83313C4.8335 8.24734 4.49771 8.58313 4.0835 8.58313C3.66928 8.58313 3.3335 8.24734 3.3335 7.83313C3.3335 7.41892 3.66928 7.08313 4.0835 7.08313C4.49771 7.08313 4.8335 7.41892 4.8335 7.83313Z"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
